<p class="alert alert-info" id="{{metadata.name}}">
  <em class="fa fa-info-circle"></em>
  <span [innerHTML]="metadata.value | sanitizeHtml"></span>
</p>
